import './App.scss';
import Home from './pages/Home';
import {Routes, Route} from 'react-router-dom';
import About from './pages/About';
import Services from './pages/Services';
import Contactus from './pages/Contact/Contactus';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/general-dentistry" element={<Services service="General Dentistry" />} />
      <Route path="/teeth-whitening" element={<Services service="Teeth Whitening" />} />
      <Route path="/root-canals" element={<Services service="Root Canals" />} />
      <Route path="/wisdom-teeth" element={<Services service="Wisdom teeth" />} />
      <Route path="/veneers" element={<Services service="Veneers" />} />
      <Route path="/dental-implants" element={<Services service="Dental Implants" />} />
      <Route path="/crowns-and-bridges" element={<Services service="Crowns and Bridges" />} />
      <Route path="/invisalign" element={<Services service="Invisalign" />} />
      <Route path="/orthodontics" element={<Services service="Orthodontics" />} />
      <Route path="/contact" element={<Contactus />} />
    </Routes>
  );
}

export default App;
